import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * Item List information.
 *
 * @export
 * @interface ItemListInformation
 */
export interface ItemListInformation {
  /**
   * Item code
   *
   * @type {string}
   * @memberof ItemListInformation
   */
  code: string;
  /**
   * Item label
   *
   * @type {string}
   * @memberof ItemListInformation
   */
  label: string;
  /**
   * Flag if item is checked
   *
   * @type {boolean}
   * @memberof ItemListInformation
   */
  checked: boolean;
  /**
   * Flag if item is added
   *
   * @type {boolean}
   * @memberof ItemListInformation
   */
  added: boolean;
}
/**
 * リストビルダー
 *【選択状態リスト:itemList:ItemListInformation[]】
 *【コードラベル内容:itemCodeLabel:string】
 *【名称ラベル内容:itemNameLabel:string】
 *【0件結果:noResult:string】
 *【0件説明:description:string】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-list-builder',
  templateUrl: './list-builder.html',
  styles: [`
    
  `]
})
export class ListBuilder extends BaseWidget {
  /**
   * 選択状態リストの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択状態リストに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 選択状態リスト
   */
  @Input() itemList:ItemListInformation[]

  /**
   * コードラベル内容
   */
  @Input() itemCodeLabel:string

  /**
   * 名称ラベル内容
   */
  @Input() itemNameLabel:string

  /**
   * 0件結果
   */
  @Input() noResult:string

  /**
   * 0件説明
   */
  @Input() description:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * Event type Change for changing checkbox
   */
  private CHANGE_EVENT = 'change';
  updateChecked(event) {
    let target = event.list;
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => target,
      {id:this.id, type: this.CHANGE_EVENT, source: null},
      `update by ${this.id}`,
    ));
    this.on(this.CHANGE_EVENT);
  }
  updateAdded(event) {
    let target = event.list;
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => target,
      {id:this.id, type:event.event.type, source:event},
      `update by ${this.id}`,
    ));
    this.on(event.event);
  }
  updateAllChecked(event) {
    let target = event.list;
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => target,
      {id:this.id, type:event.event.type, source:event},
      `update by ${this.id}`,
    ));
    this.on(event.event);
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/list_builder/list-builder/list-builder.component.ts